import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { debounceTime, filter, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { GpsService } from 'src/app/services/core/gps/gps.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()
@Component({
  selector: 'app-list-gps',
  templateUrl: './list-gps.component.html',
  styleUrls: ['./list-gps.component.css']
})
export class ListGpsComponent {
  selectedStatus: any = '';
  gps: any = [];
  totalPages = 0;
  totalResults = 0;
  currentPage: number = 1
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any
  private searchSubject = new Subject<string>();
  status = true;
  todayDate:any = [];
  userPermission = UserPermission
  user: any;
  timeZone: any = timeZone;
  currentDate: any = moment().tz(this.timeZone).toISOString()

  constructor(private gpsService: GpsService,
    private credentialService:CredentialService,
    private sharedDataService: SharedDataService
  ) {
  }

  ngOnInit() {
    this.getUser();
    this.getGps(this.currentPage);
    this.initializeSearch();
  }

  getGps(page: number) {
    const queryparams:any = {
      limit: 50,
      page,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      isActive: this.status,
      sortBy: 'createdAt:desc',
    };
    if (this.search) {
      queryparams.search = this.search.trim();
    }
    this.gpsService.get(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
        this.gps = data.results;
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    });
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3)
      )
      .subscribe(() => {
        this.currentPage = 1;
        this.getGps(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

   getUser() {
      this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
        if (data) {
          this.user = data;
          if (this.user.timeZone) {
            this.timeZone = this.user.timeZone;
          }
          this.todayDate = [
            moment().tz(this.timeZone).startOf("day"),
            moment().tz(this.timeZone).endOf("day"),
          ];
        }
  
      })
    }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.currentPage = 1;
    this.getGps(this.currentPage);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getGps(page);
  }

  onSelectStatus(event: any): void {
    this.status = event.target.value
    this.getGps(this.currentPage = 1);
  }


}
